import React from "react";
//import I18n from "i18n-js/index.js.erb"

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.selectAllNone = this.selectAllNone.bind(this);
    this.selectOne = this.selectOne.bind(this);
    this.isChecked = this.isChecked.bind(this);
    this.capitalizeFirstLetter = this.capitalizeFirstLetter.bind(this);
    this.buildCheckboxLabel = this.buildCheckboxLabel.bind(this);
  }

  render() {
    if (
      this.props.selected_inputs && this.props.selected_inputs.length !== this.props.inputs.length &&
      this.props.selected_inputs.length !== 0
    ) {
      $(this.refs.selectAll).prop("indeterminate", true);
    }

    return (
      <div>
        <div
          className="select-all-none"
          id="selected_rooms"
          style={{ marginBottom: 4 }}
        >
          <div className="toggle">
            <input
              ref="selectAll"
              type="checkbox"
              style={{ marginRight: 12 }}
              checked={
                this.props.selected_inputs && this.props.inputs.length === this.props.selected_inputs.length
                  ? true
                  : false
              }
              onChange={this.selectAllNone}
              disabled={
                this.props.inputs[0].input_status
                  ? this.props.inputs[0].input_status
                  : null
              }
            />
            {this.props.title_helper_text ? (
              <span>
                {`${
                  I18n.t(this.props.header_primary).includes("missing")
                    ? this.props.header_primary
                    : I18n.t(this.props.header_primary)
                }`}
                {this.props.header_secondary
                  ? ` (${I18n.t(this.props.header_secondary)})`
                  : ""}{" "}
                {this.props.header_third
                  ? ` (${I18n.t(this.props.header_third)})`
                  : ""}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t(this.props.title_helper_text)}
                ></span>
              </span>
            ) : (
              <span>
                {`${
                  I18n.t(this.props.header_primary).includes("missing")
                    ? this.props.header_primary
                    : I18n.t(this.props.header_primary)
                }`}
                {this.props.header_secondary
                  ? ` (${I18n.t(this.props.header_secondary)})`
                  : ""}
                {this.props.header_third
                  ? ` (${I18n.t(this.props.header_third)})`
                  : ""}
              </span>
            )}
          </div>
          <hr />
          {this.renderForm(this.props.inputs)}
        </div>
      </div>
    );
  }

  renderForm(inputs) {
    var self = this;
    var rendered_inputs = inputs.map((input) => self.renderInput(input));
    return (
      <div className="row">
        <div className="col-md-12 items-column">
          <div className="select-all-none">
            <div className="items">{rendered_inputs}</div>
          </div>
        </div>
      </div>
    );
  }

  renderInput(input) {
    return (
      <div className="item" key={input.id || input.label_primary}>
        <label className={input.label_secondary === "disabled" ? "disabled" : ""}>
          <input
            type="checkbox"
            style={{ marginRight: 12 }}
            value={input.id}
            checked={this.isChecked(input.id)}
            onChange={this.selectOne}
            disabled={input.input_status === "disabled" ? true : false}
          />
          {this.buildCheckboxLabel(input)}

          {input.status && input.status == "disabled" ? (
            <em>{` (${I18n.t("Disabled")})`}</em>
          ) : (
            null
          )}

          {this.props.showDisabledIcon == true && this.isChecked(input.id) == false ? (
            <span 
              className="ss ss-alert" 
              title={I18n.t("unselected_rates_will_be_disabled")}
              style={{paddingLeft: '5px'}}>  
            </span>   
          ) : (
            null
          )}
        </label>
      </div>
    );
  }

  buildCheckboxLabel(input) {
    var label = input.label_primary;
    if (input.label_secondary && input.label_secondary.length) {

      // *** Billing Policy Rates Multiselect *** //
      if (input.rate_status && input.rate_status === "disabled") {
        label = (
          <div style={{ color: "grey", display: "inline" }}>
            <i>
              {input.code +
                ": " +
                input.name +
                " (" +
                (input.label_secondary || I18n.t("na")) +
                ") "}
            </i>
            <span
              className="ss ss-alert"
              title={I18n.t("status_is_disabled")}
            ></span>
          </div>
        );
      } else {

        // *** Normal Multi Select *** //
        label += ` (${input.label_secondary})`;
      }
    }

    // *** Manage Rates Room Type Multi Select *** //
    if (input.custom_label_secondary && input.custom_label_secondary.length) {
      if (input.custom_label_secondary == I18n.t("none")) {
        label = (
          <span>
            {label}
            <em>{` (${this.capitalizeFirstLetter(
              input.custom_label_secondary
            )})`}</em>
          </span>
        );
      } else {
        label = (
          <span>
            {label}
            {` (${this.capitalizeFirstLetter(input.custom_label_secondary)})`}
          </span>
        );
      }
    }

    // *** Manage Product Taxes Multi Select *** //
    if (input.tax_label_secondary) {
      label = (
        <span>
          {label}
          {` (${parseFloat((input.tax_label_secondary * 100).toFixed(2))}%)`}
        </span>
      );
    }

    if (this.props.owner_details) {
      label = (
        <span>
          {label + " "}
          <span>(<span style={{ color: '#666', fontStyle: 'italic' }}>{input.owner_details_third_column || I18n.t('none')}</span>) (<span style={{ color: '#666', fontStyle: 'italic' }}>{input.owner_details_secondary_column || I18n.t('none')}</span>)</span>
        </span>
      );
    }
    return label;
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  selectAllNone(event) {
    var selected_inputs = [];
    if (event.target.checked) {
      selected_inputs = this.props.inputs.map((input) => input.id);
    }
    this.props.onChange(selected_inputs);
    $(this.refs.selectAll).prop("indeterminate", false);
  }

  selectOne(event) {
    var selected_inputs;
    if (event.target.checked) {
      selected_inputs = [...this.props.selected_inputs, event.target.value];
      if (selected_inputs.length === this.props.inputs.length) {
        $(this.refs.selectAll).prop("indeterminate", false);
      }
    } else {
      selected_inputs = this.props.selected_inputs.filter(
        (input) => input !== event.target.value
      );
      if (!selected_inputs.length) {
        $(this.refs.selectAll).prop("indeterminate", false);
      }
    }
    this.props.onChange(selected_inputs);
  }

  isChecked(id) {
    if (this.props.selected_inputs && this.props.selected_inputs.length) {
      for (let i = 0; i < this.props.selected_inputs.length; i++) {
        if (this.props.selected_inputs[i] === id) {
          return true;
        }
      }
    }
    return false;
  }
}

export default MultiSelect;
